import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  MDBAlert,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon,
  MDBModalFooter,
  MDBSpinner,
} from "mdb-react-ui-kit";
import { editRouingUser, editUserCallRouting, getSpacificRoutingInfo, updateRouingUser } from "../../../apiclients/streamsapi_bridge";
import arrow from "../../../components/images/arrow_ic.svg";

import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import AudioPlayer from "../../../components/mediaplayers/AudioPlayer";
import CallSequence from "../../../components/Sequence";
import { useAdminContext } from "../../../components/adminstore/Admin-Context";
import { SeqArrow } from "../../../components/images";
import CustomAudioPlayer from "../../../components/audioPlayer/CustomAudioPlayer";
import SequenceAudioPlayer from "../../../components/mediaplayers/SequenceAudioPlayer";

const CallRouting = forwardRef(({ isadd, onClose, planInfo, agentid, addNewPlan, isView, clonePlan, clonePlanInfo, setSuccessMessage, isDisabled, setIsChildDirty, parentDirtyFields, parentgetValues, setRerender, setErrorMessage, setAddDialPlans, setReloadPlan, useragent, dialPlanid, deviceExternalNum, callerids, createPlanFlag, planNames, greetingInfo, emessage, setEMessage, emptyDeviceIndex, setemptyDeviceIndex, setTwentyFourPlan }, ref) => {
  const { t, i18n } = useTranslation();
  const [callRoute, setCallRoute] = useState({});
  const [seq, setSeq] = useState(new Array(4));
  const [length, setLength] = useState();
  const [defaultFieldValues, setDefaultFieldValues] = useState({});
  const [allowSaveFlag, setAllowSaveFlag] = useState(true);
  const [routePlanName, setRoutePlanName] = useState("");
  // const [deviceExternalNum, setDeviceExternalNum] = useState([]);
  // const [callerids, setCallerids] = useState([]);
  const [noOfSequences, setNoOfSequences] = useState(0);
  const [noOfDevices, setNoOfDevices] = useState("");
  const [isloading, setIsloading] = useState(false);
  const { setEdited } = useAdminContext();

  const streamReq = JSON.parse(sessionStorage.getItem("admin_session"))?.isStreamReq
  const isstreamsReq = streamReq && streamReq === 1 ? true : false;

  const navigate = useNavigate();
  const { register, control, reset, getValues, watch, setValue, formState, setError, handleSubmit, unregister, clearErrors } = useForm({
    defaultValues: {
      sequences: [],
      title: "",
      deleteSeq: [],
      deleteDevice: [],
    }
  });
  const { isDirty, errors, dirtyFields } = formState;
  const { fields: seqComponent, append: appendSeq, remove: removeSeq, insert: insertSeq } = useFieldArray({
    name: 'sequences',
    control
  });
  function getLength(array) {
    let size = 0;
    for (let key in array) {
      if (array.hasOwnProperty(key)) {
        size++;
      }
    }
    return size;
  }
  function delSeq(e, seqInfo, deleteObj) {
    e.preventDefault();
    const index = parseInt(seqInfo.seqIndex);
    removeSeq(index);
    const seqNo = index + 1;
    if (deleteObj.oldseq !== "") {
      const deleteSeq = watch("delete_seq") ?? [];
      const deleteSeqNo = deleteObj.oldseq !== "" ? parseInt(deleteObj.oldseq.slice(-1)) : parseInt(deleteObj.seq.slice(-1));
      deleteSeq.push(parseInt(deleteSeqNo));
      setValue("delete_seq", deleteSeq, { shouldDirty: true });
    }
  }
  function cloneSeq(e, seqInfo, seqIndx) {
    e.preventDefault();
    insertSeq((seqIndx + 1), seqInfo);
  }
  function cloneSeqEnd(e, seqInfo) {
    e.preventDefault();
    appendSeq(seqInfo);
  }
  function addSeq(e, seqInfo) {
    e.preventDefault();
    appendSeq(seqInfo);
  }
  useEffect(() => {
    if (callRoute && callRoute.name && callRoute.name !== "" && isadd) {
      setRoutePlanName(callRoute.name);
    }

  }, [callRoute]);
  useEffect(() => {
    try {
      if (planInfo?.sequences) {
        //  planInfo.issystemroute = true;
        //alert(" ::::new::::::" +JSON.stringify(planInfo.sequences));
        setCallRoute(planInfo);
        setSeq(planInfo.sequences);
        setNoOfSequences(planInfo.sequences.length);

        setDefaultFieldValues({
          sequences: planInfo.sequences,
        });



      } else {
        if (isadd) {
          if (clonePlanInfo?.sequences) {
            setDefaultFieldValues({
              sequences: clonePlanInfo.sequences,
              title: planNames,
            })
            const clonePlan = {
              name: planNames,
              dialplanid: -1,
              // issystemroute: false,
              sequences: clonePlanInfo.sequences,
            }
            setCallRoute(clonePlan);
          } else {
            //setLength(1);
            setDefaultFieldValues({
              sequences: [
                {
                  name: "seq1",
                  oldseq: `seq1`,
                  ringtime: 20,
                  devices: prepareNewRoutingPlanDevices(),
                },
              ],
              title: planNames,
            });
            setCallRoute({
              name: planNames,
              dialplanid: -1,
              // issystemroute: false,
              sequences: [
                {
                  name: "seq1",
                  oldseq: `seq`,
                  ringtime: 20,
                  devices: prepareNewRoutingPlanDevices(),
                },
              ],
            });
          }
        } else if (isView) {
          getCallRoutes();
        } else {

          setDefaultFieldValues({
            sequences: [
              {
                name: "seq1",
                oldseq: `seq1`,
                ringtime: 20,
                devices: [],
              },
            ],
          });
        }
      }
    } catch (error) {
      console.log(error)
    }

  }, [planInfo?.sequences]);






  function prepareNewRoutingPlanDevices() {
    let deviceArray = [];
    console.log("deviceArray :::::::::::::::::::::::::  " + JSON.stringify(deviceExternalNum))
    deviceExternalNum.forEach(device => {
      if (device.id && Number.isInteger(device.id)) {
        deviceArray.push({
          deviceid: "",
          name: device.type,
          device_type: device.id,
          ftime: "12:00 AM",
          ttime: "11:59 PM",
          is24: true,
          external_num: "",
        });

      }
    });
    return deviceArray;
  }
  useEffect(() => {
    if (defaultFieldValues && Object.keys(defaultFieldValues.length > 0)) {
      reset(defaultFieldValues);
    }
  }, [defaultFieldValues]);
  async function getCallRoutes() {
    setIsloading(true);
    const response = await getSpacificRoutingInfo(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid, dialPlanid
    );
    if (response) {
      const callroute = await response.json();
      setIsloading(false);
      console.log(`Get Specific Call Routing ::::::::${JSON.stringify(callroute)}`);
      // const isCustom = isCustomPlan ?? false;

      const transformData =
        callroute?.callrouting?.devices.reduce(
          (acc, device) => {
            const sequenceIndex = device.seq - 1;
            const deviceData = {

              deviceid: device.device_id,
              name: device.device_name,
              ftime: device.from_time,
              ttime: device.to_time,
              is24: device.twentyFourEnabled,
              external_num: device?.external_num ?? "",
              device_type: device?.device_type,
              callerid_pass_flag: device?.callerid_pass_flag != undefined ? device.callerid_pass_flag : true,
              callerid_pass: device?.callerid_pass + "",

            };

            if (!acc.sequences[sequenceIndex]) {
              acc.sequences[sequenceIndex] = {
                name: `seq${device.seq}`,
                oldseq: `seq${device.seq}`,
                ringtime: device.ring_secs,
                devices: [deviceData],
              };
            } else {
              acc.sequences[sequenceIndex].devices.push(deviceData);
            }
            return acc;
          },
          {
            name: callroute?.callrouting?.title,
            dialplanid:
              callroute?.callrouting?.dial_planid,
            // issystemroute: !isCustom,
            sequences: [],
          }
        );
      console.log("==================================================" + JSON.stringify(transformData))
      setCallRoute(transformData);
      setSeq(transformData.sequences);
      setNoOfSequences(transformData.sequences.length);
      setDefaultFieldValues({
        sequences: transformData.sequences,
        title: callroute?.callrouting?.title,
      });
    }
  }

  function cloneThis(e) {
    e.preventDefault();
    clonePlan(callRoute);
    if (onClose) {
      onClose();
    }

  }

  function convertTimeTo24HourFormat(timeString) {
    const date = new Date(`2000-01-01 ${timeString}`);
    const options = { hour: 'numeric', minute: 'numeric', hour12: false };
    const time24Hour = date.toLocaleTimeString('en-US', options);
    return time24Hour;
  }

  const onsubmit = async (data) => {
    // console.log(`add Request JSON :::::::::${JSON.stringify(data)}`);
    const transformedData = data.sequences.reduce((prev, sequence) => {
      sequence.devices.forEach((device, deviceIndex) => {
        const sequenceNum = sequence.name.slice(-1);
        const tempArray = {
          seq: parseInt(sequenceNum),
          ring_secs: parseInt(sequence.ringtime),
          // from_time: convertTimeTo24HourFormat(device.ftime + ""),
          // to_time: convertTimeTo24HourFormat(device.ttime + ""),
          from_time: device.ftime,
          to_time: device.ttime,
          twentyFourHours: device.is24,
        }
        if (device?.new_external_num && device?.new_external_num != "") {
          tempArray.new_external_num = parseInt(device.new_external_num);
          tempArray.external_num_title = device.external_num_title;
          tempArray.external_num_save = device.external_num_save;
          // tempArray.device_type = null;

          tempArray.callerid_pass_flag = device?.callerid_pass_flag ?? true;
          if (!device.callerid_pass_flag) {
            tempArray.callerid_pass = device?.callerid_pass;
          }
        } else if (device?.external_num && device?.external_num != "") {
          tempArray.external_num = parseInt(device.external_num);
          // tempArray.device_type = null;
          tempArray.callerid_pass_flag = device?.callerid_pass_flag ?? true;
          if (!device.callerid_pass_flag) {
            tempArray.callerid_pass = device?.callerid_pass;
          }
        } else {
          tempArray.device_type = device.device_type + "";
        }

        prev.push(tempArray);

      });
      return prev;

    }, []);
    let update = {
      reqid: 28,
      title: data.title,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid: agentid,
      sequence_info: transformedData,
    }

    if (createPlanFlag) {
      update.isactive_plan = createPlanFlag
    }

    console.log(`Final JSON for create new routing plan :::::: ${JSON.stringify(update)}`);
    setIsloading(true);
    let saverep = await updateRouingUser(update);
    console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let saverepeMsg = await saverep.json();
    console.log("response of modified data :::" + JSON.stringify(saverepeMsg))
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      // setEdited(false);
      setSuccessMessage(saverepeMsg.message);
      if (createPlanFlag || isadd) {
        setReloadPlan(true);
        if (isadd && setTwentyFourPlan) {
          setTwentyFourPlan(0);
        }

      } else {
        const planid = saverepeMsg.dial_plan_id ?? 0;
        const newPlan = {
          name: data.title,
          dial_planid: planid,
          is_custom: true
        }
        addNewPlan(newPlan);
      }

      onClose();




    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          const param_name = err.param_name.indexOf("ring_secs") !== -1 && err.position ? `sequences.${err.position}.ring_secs` : err?.param_name;
          if (param_name) {
            setError(param_name, {
              type: "server",
              message: err.message,
            });
          }
          const fieldElement = document.querySelector(
            `input[name="${param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }
  }
  const isChildModified =
    Object.keys(formState.dirtyFields).length === 0 ? false : true;
  let isdirtyFields = false;
  useEffect(() => {
    isdirtyFields = hasAnyTrueValue(dirtyFields);
    if (setIsChildDirty) {
      setIsChildDirty(isdirtyFields);
    }


  }, [isDirty])

  const hasAnyTrueValue = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
      return obj === true;
    }

    for (const key in obj) {
      if (obj[key] === true) {
        return true;
      }
      if (typeof obj[key] === 'object') {
        if (hasAnyTrueValue(obj[key])) {
          return true;
        }
      }
    }

    return false;
  };

  // console.log("Child Dirty fields :::::::: "+isdirtyFields);

  const onMainSubmit = async (data) => {
    const isParentdirtyFields =
      Object.keys(parentDirtyFields).length === 0 ? false : true;
    const parentData = parentgetValues();

    if (isChildModified) {

      const update = processToCreateJSON(data);

      console.log("child Data :::::: " + JSON.stringify(update));

      setIsloading(true);

      let saverep = await editUserCallRouting(update);
      setTimeout(() => {
        setIsloading(false);
      }, 1000);
      console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
      let saverepeMsg = await saverep.json();
      console.log("response of modified data :::" + JSON.stringify(saverepeMsg))
      if (saverepeMsg.status && saverepeMsg.status == "success") {
        setEdited(false);

        if (isParentdirtyFields) {
          const planUpdate = changeActivePlanJson(parentDirtyFields, parentData);
          updateActivePlan(planUpdate);
        } else {
          setReloadPlan(true);
          setSuccessMessage(saverepeMsg.message);
        }


      } else {
        if (saverepeMsg.message?.errors) {
          saverepeMsg.message.errors.forEach((err) => {
            let param_name = err.param_name.indexOf("ring_secs") !== -1 && err.position ? `sequences.${err.position}.ring_secs` : null;
            param_name = err.param_name.indexOf("callerid_pass") !== -1 ? `sequences.${err.seq - 1}.devices.${err.device_index}.callerid_pass` : param_name;
            if (param_name) {
              setError(param_name, {
                type: "server",
                message: err.message,
              });
            }
            const fieldElement = document.querySelector(
              `input[name="${param_name}"]`
            );
            if (fieldElement) {
              fieldElement.focus();
              fieldElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      }

    }

    if (isParentdirtyFields) {

      const planUpdate = changeActivePlanJson(parentDirtyFields, parentData);
      updateActivePlan(planUpdate);
    }

  }

  async function updateActivePlan(planUpdate) {
    setIsloading(true);
    let saverep = await editRouingUser(planUpdate);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let saverepeMsg = await saverep.json();
    console.log("saverepeMsg ::::::::::: " + JSON.stringify(saverepeMsg));
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setEdited(false);
      setReloadPlan(true);
      setSuccessMessage(saverepeMsg.message);
    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          if (err.param_name === "logined_user") {
            setErrorMessage(err.message);
          }
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
          const fieldElement = document.querySelector(
            `input[name="${err.param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }
    if (saverep.status === 200) {
      setAddDialPlans([]);
      setReloadPlan(true);
    }



  }
  const changeActivePlanJson = (parentDirtyFields, parentData) => {
    let modifiedField = {};
    if (parentDirtyFields) {
      // const dirtyFields = formState.dirtyFields;
      for (const field of Object.keys(parentDirtyFields)) {
        if (parentDirtyFields[field] && parentData.hasOwnProperty(field)) {
          modifiedField[field] = parentData[field];
        }
      }
      if (modifiedField) {
        modifiedField.reqid = 33;
        modifiedField.siteid = JSON.parse(
          sessionStorage.getItem("admin_session")
        ).siteid;
        modifiedField.agentid = useragent;
        // console.log("new values are parent values ::::::: "+JSON.stringify(parentgetValues()))
        modifiedField.issched_days = parentgetValues().issched_days;
        console.log("Change Plan Json object :::: " + JSON.stringify(modifiedField));

      }
    }
    return modifiedField;
  }

  const processToCreateJSON = (data) => {
    let updateObj = {};
    let add_seq = {};
    let edit_Seq = {};
    let temp_edit = [];
    console.log("Device Data ::::::: " + JSON.stringify(data));
    console.log("Device DirtyField ::::::: " + JSON.stringify(dirtyFields));
    const updateDirtyFields = dirtyFields

    if (data?.delete_new_Device && data?.delete_new_Device.length > 0) {

      data?.delete_new_Device.forEach(indexString => {
        const [seqIndex, deviceIndex] = indexString.split("_");
        if (dirtyFields.sequences[seqIndex]?.devices[deviceIndex]?.newDevice || dirtyFields.sequences[seqIndex]?.devices[deviceIndex]?.editDevice) {

          updateDirtyFields.sequences[seqIndex].devices.splice(deviceIndex, 1);
        }
      })
    }

    console.log("updateDirtyFields ::::::::::::: " + JSON.stringify(updateDirtyFields));

    const emptyDevices = data.sequences.filter((seq) => seq.devices.length === 0).map((seq) => parseInt(seq.name.replace(/\D/g, ""), 10));
    if (emptyDevices?.length > 0) {
      setemptyDeviceIndex(emptyDevices);
      setEMessage(`You have created the sequence(s), but a device has not been added. Please include a device in the sequence(s) and try again.`);
      return;
    }
    data.sequences.forEach((sequence, index) => {
      let add_device = [];
      let edit_device = [];
      // const modifiedDirtyFields = updateDirtyFields?.sequences[index]?.devices?.filter((item) => {
      //   return (item.newDevice || item.editDevice);
      // }) ?? [];



      const modifiedDirtyFields = Array.isArray(updateDirtyFields?.sequences?.[index]?.devices)
        ? updateDirtyFields.sequences[index].devices.filter((item) => {
          return item.newDevice || item.editDevice;
        })
        : [];
      const modifiedDataFields = Array.isArray(updateDirtyFields?.sequences?.[index]?.devices)
        ? sequence?.devices?.filter((item, index) => {
          if (item.callerid_pass_flag == false) {
            item.device_index = index;
          }
          return (item.newDevice || item.editDevice);
        }) : [];

      console.log("modifiedDirtyFields :::::::::::::: " + JSON.stringify(modifiedDirtyFields));
      console.log("modifiedDataFields :::::::::::::: " + JSON.stringify(modifiedDataFields));
      modifiedDataFields.forEach((device, devIndex) => {
        let deviceObj = {};
        const dirtyFieldsData = modifiedDirtyFields[devIndex];
        const newDevice = device.newDevice
        if (newDevice) {
          deviceObj = { ...device, seq: parseInt(sequence.name.slice(-1)), ring_secs: parseInt(sequence.ringtime) }
          delete deviceObj.deviceid;
          if (deviceObj.device_type !== 5) {
            delete deviceObj.callerid_pass_flag;
            delete deviceObj.callerid_pass;
            delete deviceObj.external_num_save;
            delete deviceObj.displayCallerId;
            delete deviceObj.newDevice;
            delete deviceObj.new_external_num;
            delete deviceObj.external_num_title;
            delete deviceObj.external_num;
            deviceObj.device_type = deviceObj.device_type + "";

          } else {
            for (const field of Object.keys(deviceObj)) {
              if (deviceObj[field] === "") {
                delete deviceObj[field];
              }
            }
            deviceObj.device_type = "null";
            deviceObj.external_num_title = deviceObj.name ? deviceObj.name.split(":")[0]?.trim() : undefined;
            if (deviceObj.external_num !== undefined) {
              deviceObj.external_num = parseInt(deviceObj.external_num);
            }
          }
          if (!deviceObj.is24) {
            delete deviceObj.is24;
          }
          delete deviceObj.ftime;
          delete deviceObj.ttime;
          delete deviceObj.name;
          if (deviceObj.newDevice) {
            delete deviceObj.newDevice;
          }
          if (deviceObj.displayCallerId) {
            delete deviceObj.displayCallerId;
          }
          if (deviceObj.callerid_pass) {
            delete deviceObj.callerid_pass;
            deviceObj.callerid_pass = device.callerid_pass;
          }


          deviceObj.from_time = device.ftime;
          deviceObj.to_time = device.ttime;
          if (deviceObj.callerid_pass_flag != undefined) {
            delete deviceObj.callerid_pass_flag;
            deviceObj.callerid_pass_flag = device.callerid_pass_flag;
          }
          if (deviceObj?.is24 != undefined) {
            delete deviceObj.is24
            deviceObj.twentyFourHours = device.is24;
          }
          add_device.push(deviceObj);
        } else {
          deviceObj = { ...device }
          delete deviceObj.deviceid;
          for (const field of Object.keys(deviceObj)) {
            if (!dirtyFieldsData[field]) {
              delete deviceObj[field];
            } else if (field === 'ftime' || field === 'ttime') {
              delete deviceObj[field];
              const fielname = field === 'ftime' ? 'from_time' : 'to_time';
              deviceObj[fielname] = device[field];
            } else if (field === "external_num" && deviceObj[field] === "") {
              delete deviceObj[field];
            }
          }
          deviceObj.device_id = parseInt(device.deviceid);
          deviceObj.seq = parseInt(sequence.oldseq.slice(-1));
          deviceObj.device_type = device.device_type === 5 ? null : parseInt(device.device_type);
          if (device.device_type === 5 && device.callerid_pass_flag == false) {
            deviceObj.callerid_pass = device?.callerid_pass == "null" ? "0" : device?.callerid_pass;
          }
          if (device.device_index >= 0 && device.device_type === 5) {
            deviceObj.device_index = device.device_index;
          }
          if (updateDirtyFields?.sequences[index]?.ringtime) {
            deviceObj.ring_secs = parseInt(sequence.ringtime);
          }
          delete deviceObj.editDevice;
          delete deviceObj.name;
          delete deviceObj.device_type;
          if (deviceObj?.is24 != undefined) {
            delete deviceObj.is24
            deviceObj.twentyFourHours = device.is24;
          }
          edit_device.push(deviceObj);
        }
      })

      if (sequence.oldseq === "") {
        delete sequence.newSeq;
        if (add_device.length > 0) {
          const pevadd = add_seq?.add_device ?? []
          add_seq = { add_device: [...pevadd, ...add_device] };
        }
      } else {
        if (add_device.length > 0) {
          const pevadd = edit_Seq?.add_device ?? []
          edit_Seq.add_device = [...pevadd, ...add_device];
        }
        if (edit_device.length > 0) {
          const pevedit = edit_Seq?.edit_device ?? []
          edit_Seq.edit_device = [...pevedit, ...edit_device];
        }
        if (
          (!(Array.isArray(updateDirtyFields?.sequences) &&
            updateDirtyFields.sequences[index] &&
            Array.isArray(updateDirtyFields.sequences[index]?.devices)) || (add_device.length === 0 && edit_device.length === 0)) && (Array.isArray(updateDirtyFields.sequences) && updateDirtyFields.sequences[index] && updateDirtyFields.sequences[index]?.ringtime)) {
          let deviceObj = {
            ring_secs: parseInt(sequence.ringtime),
            seq: parseInt(sequence.oldseq.slice(-1))
          }
          temp_edit.push(deviceObj);

        }
      }
    });
    if (data.device_id && data.device_id.length > 0) {
      const deleteDeviceId = data.device_id.filter(id => !(data.delete_seq && data.delete_seq.includes(parseInt(id.split("_")[1]))));
      const deleteid = [];
      deleteDeviceId.map(ids => deleteid.push(parseInt(ids.split("_")[0])));
      if (deleteid.length > 0) {
        edit_Seq.delete_device = deleteid;
      }
    }
    let sequence_info = {}
    if (Object.keys(add_seq).length > 0) {
      sequence_info.add_seq = add_seq;
    }
    if (Object.keys(edit_Seq).length > 0) {
      sequence_info.edit_seq = edit_Seq;
    }
    if (sequence_info && Object.keys(sequence_info).length === 0 && temp_edit.length > 0) {

      const editDevice = {
        edit_device: temp_edit
      }
      sequence_info.edit_seq = editDevice;

    }
    if (data.delete_seq && data.delete_seq.length > 0) {
      sequence_info.delete_seq = data.delete_seq;
    }

    if (sequence_info.edit_seq && !sequence_info.edit_seq.edit_device && !sequence_info.edit_seq.add_device && temp_edit.length > 0) {
      const editDevice = {
        edit_device: temp_edit
      }
      sequence_info.edit_seq = { ...sequence_info.edit_seq, ...editDevice };
    }



    console.log("final sequence info ::::::::::::: " + JSON.stringify(sequence_info));
    updateObj = {
      reqid: 39,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      agentid: agentid,
      dialplan_id: parseInt(dialPlanid)
    }
    if (Object.keys(sequence_info).length !== 0) {
      updateObj.sequence_info = sequence_info;

    }
    if (updateDirtyFields?.title) {
      updateObj.title = data.title;
    }

    console.log("final final final sequence info ::::::::::::: " + JSON.stringify(updateObj))
    return updateObj;

  }

  const onEditSubmit = async (data) => {
    const update = processToCreateJSON(data);
    setIsloading(true);
    let saverep = await editUserCallRouting(update);
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log("response of modified data :::" + JSON.stringify(saverepeMsg))
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      setEdited(false);
      setSuccessMessage(saverepeMsg.message);
      onClose();
      setReloadPlan(true);


    } else {
      if (saverepeMsg.message?.errors) {
        saverepeMsg.message.errors.forEach((err) => {
          const param_name = err.param_name.indexOf("ring_secs") !== -1 && err.position ? `sequences.${err.position}.ring_secs` : err.param_name;
          if (param_name) {
            setError(param_name, {
              type: "server",
              message: err.message,
            });
          }
          const fieldElement = document.querySelector(
            `input[name="${param_name}"]`
          );
          if (fieldElement) {
            fieldElement.focus();
            fieldElement.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }
  }

  // useEffect(() => {
  //   if (agentid && agentid != "") {
  //     getDeviceExternalNumber();
  //     getCallerIds();
  //   }

  // }, [agentid]);

  // const navigate = useNavigate();

  // async function getDeviceExternalNumber() {
  //   console.log(sessionStorage.getItem("admin_session"));
  //   const response = await getMisc(
  //     JSON.parse(sessionStorage.getItem("admin_session")).siteid,
  //     { misc: ["devices"], agentid: agentid }
  //   );
  //   console.log(response);
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const tdata = await response.json();
  //   if (!tdata) {
  //     window.alert(`info with id  not found`);
  //     navigate("/");
  //   }
  //   console.log(tdata);
  //   setDeviceExternalNum(tdata?.misc?.devicesList ?? []);
  // }
  // async function getCallerIds() {
  //   console.log(sessionStorage.getItem("admin_session"));
  //   const response = await getMisc(
  //     JSON.parse(sessionStorage.getItem("admin_session")).siteid,
  //     { misc: ["callerid_list"] }
  //   );
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const tdata = await response.json();
  //   if (!tdata) {
  //     window.alert(`info with id  not found`);
  //     //navigate("/");
  //   }
  //   setCallerids(tdata?.misc?.callerid_list ?? []);
  // }

  return (
    <>
      <div
        {...(isDisabled && !(isstreamsReq)
          ? {
            title:
              "Do not have previlege to edit user",
            className: "d-flex flex-column w-100 disabled-form cursor-notAllowed",
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
          }
          : { className: "d-flex flex-column w-100" })}
      >
        {/* <div className={`d-flex flex-column w-100 ${isDisabled && !(isstreamsReq) && 'disabled-form cursor-notAllowed'}`}
        title={isDisabled && !(isstreamsReq) && "Do not have previlege to edit user"}
        
      > */}
        {/* <form> */}

        {/* {!callRoute.issystemroute && (  */}
        <>

          <div className="add-numbermain mt-0">
            {(isadd || isView) && (
              <>
                <div className="d-flex align-items-center w-80">
                  <div className="tel-numbers fs-6 w-20">{t("RoutingPlanName")} </div>
                  <div>
                    <input
                      type="text"
                      maxLength={30}
                      className="form-control w-60 p-1 ms-2"
                      {...register("title", { required: "Name should not be empty" })}
                    />
                    {errors.title && (
                      <p className="text-danger text-start">{errors.title.message}</p>
                    )}
                  </div>
                </div>
              </>
            )}
            {/* {!isadd && callRoute.issystemroute && (
              <>
                <div>
                  <div className={!isView ? (isDisabled ? "SequenceClonePlanBtn cursor-notAllowed" : "SequenceClonePlanBtn") : (isDisabled ? "cursor-notAllowed" : "")}
                    {...(isDisabled ? {
                      onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }
                    } : {
                      onClick: (e) => {
                        cloneThis(e)
                      }
                    }
                    )}                   >
                    <MDBBtn>
                      <MDBIcon far icon="clone" className="me-2" />
                      {t("CloneRoutingPlan")}
                    </MDBBtn>
                  </div>
                </div>
              </>
            )} */}

            {!isadd && seqComponent.length < 4 && dialPlanid !== 0 && (
              <div className={!isView ? "SequenceClonePlanBtn" : ""}>
                <div
                  {...(isDisabled ? {
                    onClick: (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  } : {
                    onClick: (e) => {
                      addSeq(e, { newSeq: true, name: `seq${seqComponent.length + 1}`, oldseq: "", ringtime: 20, devices: [] })
                    }
                  }
                  )}
                >
                  <MDBBtn>
                    <MDBIcon far icon="clone" className="me-2" />
                    {t("Addsequence")}
                  </MDBBtn>
                </div>
              </div>
            )}
            {isadd && seqComponent.length < 4 && (
              <div
                {...(isDisabled ? {
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                } : {
                  onClick: (e) => {
                    addSeq(e, { name: `seq${seqComponent.length + 1}`, oldseq: "", ringtime: 20, devices: [] })
                  }
                }
                )}
              >
                <MDBBtn>
                  <MDBIcon fas icon="plus" color="white" className="me-1" />
                  {t("Addsequence")}
                </MDBBtn>
              </div>
            )}

          </div>
        </>
        {/* )}  */}
        {emessage && (
          <span className="alert-msgnonc text-danger">{emessage}</span>
        )}

        <div className="d-flex justify-content-start align-items-start mob-align-center mob-flex-col overflow-x-auto py-2 flex-nowrap">
          {seqComponent &&
            seqComponent.length > 0 &&
            seqComponent.map((seqField, seqIndex) => (


              <>
                <div key={seqField.id}>
                  <CallSequence
                    item={seqField}
                    seqIndex={seqIndex}
                    // issystemroute={callRoute.issystemroute}
                    onCloneSeq={cloneSeq}
                    onCloneSeqEnd={cloneSeqEnd}
                    size={seqComponent.length}
                    onDelSeq={delSeq}
                    register={register}
                    getValues={getValues}
                    setValue={setValue}
                    control={control}
                    isadd={isadd}
                    setAllowSaveFlag={setAllowSaveFlag}
                    deviceExternalNum={deviceExternalNum}
                    callerids={callerids}
                    unregister={unregister}
                    isDisabled={isDisabled}
                    reset={reset}
                    dirtyFields={dirtyFields}
                    watch={watch}
                    seqList={seqComponent}
                    errors={errors}
                    clearErrors={clearErrors}
                    emptyDeviceIndex={emptyDeviceIndex}
                    setemptyDeviceIndex={setemptyDeviceIndex}
                    setEMessage={setEMessage}

                  />
                </div>
                {/* <div>
                  <img src={arrow} className="w_80px ip-rorate-90 py-15" />
                </div> */}
                <div className='arrow-container'>
                  <img src={SeqArrow} alt="" className='seq-arrow' />

                  <div className="bouncing-dot">
                    <button class="seq-button">
                    </button>
                  </div>
                </div>


              </>
            ))}
          {/* <div className="sequence-small mt-2">
            <div className="sequenceheader d-flex flex-column align-items-center">
              <label className="fw-bold  fs-5">{t("Voicemail")}</label>
              <div>
                <img src={voicemail} className="mb-2" />
              </div>
            </div>
          </div> */}


          <div className="seq-bg seq-vm-bg">
            <div className="d-flex align-items-center justify-content-between p-2">
              <h5 className='m-0'>Voice Mail</h5>

            </div>

            <MDBCard className='mt-2 p-0 rounded-3'>
              <MDBCardBody className='p-2 rounded-3 pt-3'>
                {agentid && agentid !== '' && (<SequenceAudioPlayer
                  uniqueId={agentid}
                  greetingType={greetingInfo?.unavailable?.greeting_type ?? 1}
                  greetingId={greetingInfo?.unavailable?.greeting_id ?? 0}
                  fileName={greetingInfo?.unavailable?.filename ?? ''}
                  greetingTitle = {greetingInfo?.unavailable?.title ?? ""}
                  title={t("VoicemailUnavailableGreeting")}
                  greetingMode={greetingInfo?.unavailable?.filename ?? '' !== '' ? 1 : 2}
                  greetingName={t("unavaliableGreeting")}
                  greetingObject = {greetingInfo?.unavailable ?? null}
                />)
                }


                {/* <div className="border-bottom border border-dashed my-3" />


                {agentid && agentid !== '' && (<SequenceAudioPlayer
                  uniqueId={agentid}
                  greetingType={greetingInfo?.busy?.greeting_type ?? 2}
                  greetingId={greetingInfo?.busy?.greeting_id ?? 0}
                  fileName={greetingInfo?.busy?.filename ?? ''}
                  title={t("VoicemailBusyGreeting")}
                  greetingMode={greetingInfo?.busy?.filename ?? '' !== '' ? 1 : 2}
                  greetingName={"Busy Greeting"}
                />)
                } */}
              </MDBCardBody>
            </MDBCard>

          </div>















          {/* <div className=" sequence overflow-hidden p-0 mt-2" style={{ border: "2px solid rgb(255, 200, 0)" }}>
            <div className="yellowNodeHeader p-2">
              Voice Mail
            </div>
            <div className="p-2 mt-3">
              <div class="tel-numbers fw-bold">{t("unavaliableGreeting")}</div>
              <div className="d-flex flex-column align-items-center customAudioPlayer">

                {agentid && agentid !== '' && (<SequenceAudioPlayer
                  uniqueId={agentid}
                  greetingType={greetingInfo?.unavailable?.greeting_type ?? 1}
                  greetingId={greetingInfo?.unavailable?.greeting_id ?? 0}
                  fileName={greetingInfo?.unavailable?.filename ?? ''}
                  title={t("VoicemailUnavailableGreeting")}
                  greetingMode={greetingInfo?.unavailable?.filename ?? '' !== '' ? 1 : 2}
                  greetingName={t("unavaliableGreeting")}
                />)
                }
              </div>
              {/* Hide busy greeting from user_call routing  */}
          {/* <div class="tel-numbers fw-bold mt-3">Busy Greeting</div>
              <div className="d-flex flex-column align-items-center">
                {agentid && agentid !== '' && (<AudioPlayer
                  uniqueId={agentid}
                  greetingType={greetingInfo?.busy?.greeting_type ?? 2}
                  greetingId={greetingInfo?.busy?.greeting_id ?? 0}
                  fileName={greetingInfo?.busy?.filename ?? ''}
                  title={t("VoicemailBusyGreeting")}
                  greetingMode={greetingInfo?.busy?.filename ?? '' !== '' ? 1 : 2}
                />)
                }
              </div> 
            </div>
          </div> */}

        </div>
        {isadd && (
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={(e) => onClose(e)}>
              {t("cancel")}
            </MDBBtn>
            <MDBBtn
              disabled={allowSaveFlag}
              onClick={handleSubmit(onsubmit)}
            >{t("Save")}</MDBBtn>
          </MDBModalFooter>
        )}
        {(isView && isChildModified) && (
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={(e) => { onClose(e); setEMessage("") }}>
              {t("cancel")}
            </MDBBtn>
            <MDBBtn
              //  disabled={allowSaveFlag}
              onClick={handleSubmit(onEditSubmit)}
            >{t("Save")}</MDBBtn>
          </MDBModalFooter>
        )}
        {(!isView && !isadd) && (
          <>
            <div style={{ display: "none" }}>
              <button ref={ref} onClick={handleSubmit(onMainSubmit)}>
                {t("Save")}</button>
            </div>
          </>
        )}
        {/* </form> */}
      </div>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}

      {/* {emessage && (
        <MDBAlert
          open
          className="alert-center alert-popup w-30 shadow-1"
          color="danger"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <span className="alert-msgnonc">{emessage}</span>
        </MDBAlert>
      )} */}


    </>
  );
});
export default CallRouting;